import type { ReactNode } from 'react';
import { BottomTabProvider } from '@/shared/contexts/bottom-tab-context';
import { PersistentBottomTab } from './persistent-bottom-tab';

interface AppWrapperProps {
  children: ReactNode;
}

export function AppWrapper({ children }: AppWrapperProps) {
  return (
    <BottomTabProvider>
      {children}
      <PersistentBottomTab />
    </BottomTabProvider>
  );
}
